export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-brand text-white">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-5">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-4 md:mb-5">
          <div>
            <span className="text-lg md:text-xl font-bold mb-1.5 md:mb-2 block">Airdog</span>
            <p className="text-white/80 leading-relaxed mb-2 text-xs font-medium">
              Medical-grade air purification technology for healthier indoor environments.
            </p>
            <button
              onClick={() => scrollTo("products")}
              className="rounded-lg font-semibold transition-all duration-200 active:scale-[0.98] inline-block text-center border-2 border-white text-white hover:bg-white hover:text-brand text-xs px-3 py-1.5"
            >
              Protect Your Home
            </button>
          </div>

          <div>
            <span className="font-semibold text-xs md:text-sm mb-1.5 md:mb-2 block">Quick Links</span>
            <ul className="space-y-1.5">
              {[
                { label: "Products", id: "products" },
                { label: "Support", id: "support" },
                { label: "About", id: "about" },
                { label: "Contact", id: "contact" },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-white/80 hover:text-white transition-colors duration-200 text-xs"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="font-semibold text-xs md:text-sm mb-1.5 md:mb-2 block">Contact</span>
            <ul className="space-y-1.5">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-xs" />
                <span className="text-white/80 font-medium text-xs">support@airdog.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-xs" />
                <span className="text-white/80 font-medium text-xs">1-800-AIRDOG-1</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-xs" />
                <span className="text-white/80 font-medium text-xs">San Francisco, CA</span>
              </li>
            </ul>
          </div>

          <div>
            <span className="font-semibold text-xs md:text-sm mb-1.5 md:mb-2 block">Shop</span>
            <button
              onClick={() => scrollTo("products")}
              className="rounded-lg font-semibold transition-all duration-200 active:scale-[0.98] inline-block text-center bg-white text-brand hover:bg-white/90 w-full text-xs px-3 py-1.5"
            >
              Shop the Collection
            </button>
          </div>
        </div>

        <div className="border-t border-white/20 pt-3 md:pt-4 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-white/60 text-xs font-medium">&copy; {new Date().getFullYear()} Airdog. All rights reserved.</p>
          <div className="flex gap-3 md:gap-4">
            <a href="#privacy" className="text-white/60 hover:text-white text-xs transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#terms" className="text-white/60 hover:text-white text-xs transition-colors duration-200">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}